import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState, useRef } from 'react';
import { Button, Form, Row, Col, Alert } from 'react-bootstrap'; // Adicionado Alert
import { Link, useNavigate } from 'react-router-dom';
import { PromotoraDTO } from '../../../shared/dto/promotoraDTO';
import { MatrizDTO } from '../../../shared/dto/matrizDTO';
import Spinner from '../../../shared/spinner';
import { ButtonAlterar, ButtonAtivar, ButtonEmpregador, ButtonFinanciamento, ButtonInativar, ButtonInfoGerais } from '../../../shared/buttons';
import PromotoraService from '../../../services/promotoraService';
import MatrizService from '../../../services/matrizService';
import ImportacaoService from '../../../services/importacaoService'; // <--- Importado
import ConfirmModal from '../../../shared/customAlertConfirm';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import ResponsivePagination from 'react-responsive-pagination';
import { faFilter, faRefresh, faFileImport, faDownload, faTimes } from '@fortawesome/free-solid-svg-icons'; // <--- Novos ícones
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Matriz } from '../../../shared/model/matriz';
import { cnpj } from 'cpf-cnpj-validator';
import { ProtectedActionInterno } from '../../../AccessControl';
import { useSlug } from '../../hooks/UseSlug';
import { ProtectedAction } from '../../../AccessControl';
import { Originador } from '../../../shared/model/originador';

function PromotoraComponent() {
  useVerificaPermissao();
  const navigate = useNavigate();

  // Services
  const promotoraService: PromotoraService = new PromotoraService();
  const matrizService = new MatrizService();
  const importacaoService = new ImportacaoService(); // <--- Instância

  // States Principais
  const [loading, setLoading] = useState(true);
  const [promotora, setPromotora] = useState<PromotoraDTO[]>([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState<{ id: any; ativo: boolean } | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const slug = useSlug(); // 2. Obtendo o slug  

  // Controle de Painéis
  const [filtros, setFiltros] = useState(false);
  const [importacaoOpen, setImportacaoOpen] = useState(false); // <--- State do Painel Importação

  // Filtros States
  const [matrizFiltro, setMatrizFiltro] = useState<string>('');
  const [codigoFiltro, setCodigoFiltro] = useState('');
  const [nomeFiltro, setNomeFiltro] = useState('');
  const [nomeFantasiaFiltro, setNomeFantasiaFiltro] = useState('');
  const [cnpjFiltro, setCnpjFiltro] = useState('');
  const [cidadeFiltro, setCidadeFiltro] = useState('');
  const [statusOrigemFiltro, setStatusOrigemFiltro] = useState('');
  const [matrizes, setMatrizes] = useState<MatrizDTO[]>([]);

  // States de Importação
  const [fileToUpload, setFileToUpload] = useState<File | null>(null);
  const [importLoading, setImportLoading] = useState(false);
  const [importMessage, setImportMessage] = useState<{ type: 'success' | 'danger', text: string } | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const pageSize = 10;

  // --- Toggle Painéis ---
  const toggleFiltros = () => {
    setFiltros(!filtros);
    setImportacaoOpen(false); // Fecha importação ao abrir filtros
  };

  const toggleImportacao = () => {
    setImportacaoOpen(!importacaoOpen);
    setFiltros(false); // Fecha filtros ao abrir importação
    setImportMessage(null);
  };

  // --- Funções de Listagem ---
  const listAllPromotora = async (page = 1) => {
    try {
      setLoading(true);

      const filtrosData: any = {};
      if (matrizFiltro) filtrosData.matriz = matrizFiltro;
      if (codigoFiltro) filtrosData.codigo = codigoFiltro;
      if (nomeFiltro) filtrosData.nome = nomeFiltro;
      if (nomeFantasiaFiltro) filtrosData.nomeFantasia = nomeFantasiaFiltro;
      if (cnpjFiltro) filtrosData.cnpj = cnpjFiltro;
      if (cidadeFiltro) filtrosData.cidade = cidadeFiltro;
      if (statusOrigemFiltro !== '') filtrosData.ativo = statusOrigemFiltro;

      const response = await promotoraService.listarTodasPromotoras(page - 1, pageSize, filtrosData);
      const data = response.data;

      setPromotora(data.content || data);
      setTotalPages(data.totalPages || 1);

      setCurrentPage(page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page: number) => {
    listAllPromotora(page);
  };

  const ativarInativarPromotora = async (id: any, ativo: boolean) => {
    setCurrentAction({ id, ativo });
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    if (currentAction) {
      const { id, ativo } = currentAction;
      try {
        await promotoraService.ativarInativarPromotora(id);
        listAllPromotora();
      } catch (err) {
        console.error(err);
      } finally {
        setConfirmOpen(false);
        setCurrentAction(null);
      }
    }
  };

  function formatarCNPJ(valor: string): string {
    valor = valor.replace(/\D/g, '');
    valor = valor.replace(/^(\d{2})(\d)/, '$1.$2');
    valor = valor.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    valor = valor.replace(/\.(\d{3})(\d)/, '.$1/$2');
    valor = valor.replace(/(\d{4})(\d)/, '$1-$2');
    return valor.slice(0, 18);
  }

  // --- LÓGICA DE IMPORTAÇÃO ---
  const handleDownloadModelo = async () => {
    try {
      // Chama o endpoint passando 'PROMOTORA'
      const response = await importacaoService.baixarModelo('PROMOTORA');

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'modelo_importacao_promotora.xlsx');
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (error) {
      console.error("Erro ao baixar modelo", error);
      setImportMessage({ type: 'danger', text: 'Erro ao baixar o modelo.' });
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setImportMessage(null);
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const extension = file.name.split('.').pop()?.toLowerCase();

      if (extension !== 'xlsx' && extension !== 'csv') {
        setImportMessage({ type: 'danger', text: 'Formato inválido. Apenas .xlsx e .csv são permitidos.' });
        setFileToUpload(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      setFileToUpload(file);
    }
  };

  const handleImportar = async () => {
    if (!fileToUpload) {
      setImportMessage({ type: 'danger', text: 'Selecione um arquivo para importar.' });
      return;
    }

    try {
      setImportLoading(true);
      // Chama o endpoint de importação 'PROMOTORA'
      await importacaoService.importar('PROMOTORA', fileToUpload);

      setImportMessage({ type: 'success', text: 'Importação realizada com sucesso!' });
      setFileToUpload(null);
      if (fileInputRef.current) fileInputRef.current.value = "";

      // Recarrega lista
      listAllPromotora(1);

      // Fecha painel após sucesso
      setTimeout(() => {
        setImportacaoOpen(false);
        setImportMessage(null);
      }, 3000);

    } catch (error: any) {
      console.error("Erro na importação", error);
      const msg = error.response?.data || 'Erro ao processar importação.';
      setImportMessage({ type: 'danger', text: msg });
    } finally {
      setImportLoading(false);
    }
  };

  useEffect(() => {
    listAllPromotora(1);

    const carregarMatrizes = async () => {
      try {
        const response = await matrizService.listarTodasMatrizesAtivas();
        setMatrizes(response.data || []);
      } catch (error) {
        console.error("Erro ao carregar matrizes:", error);
      }
    };

    carregarMatrizes();
  }, []);

  return (
    <>
      <div className="position-relative m-md-3">
        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h5>Origens &gt; Promotora</h5>
          <div style={{ display: 'flex', gap: '10px' }}>
            {/* Botão Filtros */}
            <Button id="App-button-cor-principal-escura" onClick={toggleFiltros} active={filtros}>
              <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
              Filtros
            </Button>

            {/* Botão Importar */}
            <ProtectedActionInterno>
              <Button variant="outline-primary" onClick={toggleImportacao} active={importacaoOpen}>
                <FontAwesomeIcon icon={faFileImport} style={{ marginRight: '10px' }} />
                Importar
              </Button>
            </ProtectedActionInterno>

            {/* Botão Nova */}
            <ProtectedAction>
              <Button
                onClick={() => navigate(`${slug ? `/${slug}` : ''}/origens-promotora/inclusao`, { state: { id: null } })}
                id="App-button-cor-principal-escura"
              >
                + Nova Promotora
              </Button>
            </ProtectedAction>
          </div>
        </div>

        {/* --- ÁREA DE IMPORTAÇÃO --- */}
        {importacaoOpen && (
          <div className="card card-body mb-4" style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6' }}>
            <h6 className="card-title mb-3">
              <FontAwesomeIcon icon={faFileImport} className="me-2" />
              Importação em Lote
            </h6>
            <Row className="align-items-end g-3">
              <Col md={3}>
                <Form.Label>Passo 1: Modelo</Form.Label>
                <Button variant="outline-secondary" className="w-100" onClick={handleDownloadModelo}>
                  <FontAwesomeIcon icon={faDownload} className="me-2" />
                  Baixar Modelo
                </Button>
              </Col>

              <Col md={5}>
                <Form.Group controlId="formFile">
                  <Form.Label>Passo 2: Selecione o Arquivo (.xlsx)</Form.Label>
                  <Form.Control
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept=".xlsx, .csv"
                  />
                </Form.Group>
              </Col>

              <Col md={4} className="d-flex gap-2">
                <Button
                  id="App-button-cor-principal-escura"
                  className="flex-grow-1"
                  onClick={handleImportar}
                  disabled={!fileToUpload || importLoading}
                >
                  {importLoading ? <Spinner loading={true} /> : 'Confirmar Importação'}
                </Button>
                <Button variant="secondary" onClick={() => {
                  setImportacaoOpen(false);
                  setImportMessage(null);
                  setFileToUpload(null);
                }}>
                  <FontAwesomeIcon icon={faTimes} />
                </Button>
              </Col>
            </Row>

            {importMessage && (
              <Alert variant={importMessage.type} className="mt-3 mb-0">
                {importMessage.text}
              </Alert>
            )}
          </div>
        )}

        {/* --- ÁREA DE FILTROS --- */}
        {filtros ?
          <>
            <Row className="mb-4" style={{ marginTop: '15px' }}>
              <Form.Group as={Col} md='2' controlId="formSelectMatriz">
                <Form.Label>Matriz</Form.Label>
                <Form.Select value={matrizFiltro} onChange={(e) => setMatrizFiltro(e.target.value)}>
                  <option value="">Selecione</option>
                  {matrizes.map((matriz) => (
                    <option key={matriz.id} value={String(matriz.id)}>
                      {matriz.id} - {matriz.nome}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group as={Col} md='2' controlId="formBasicSelect">
                <Form.Label>Código </Form.Label>
                <input type="text" className="form-control" value={codigoFiltro} onChange={(e) => setCodigoFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formBasicSelect">
                <Form.Label>Nome</Form.Label>
                <input type="text" className="form-control" value={nomeFiltro} onChange={(e) => setNomeFiltro(e.target.value)} />
              </Form.Group>

              <Form.Group as={Col} md='4' controlId="formBasicSelect">
                <Form.Label>CNPJ</Form.Label>
                <input
                  type="text"
                  className="form-control"
                  value={cnpjFiltro}
                  onChange={(e) => setCnpjFiltro(formatarCNPJ(e.target.value))}
                  maxLength={18}
                />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formBasicSelect">
                <Form.Label>Cidade</Form.Label>
                <input type="text" className="form-control" value={cidadeFiltro} onChange={(e) => setCidadeFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formSelectStatusOrigem">
                <Form.Label>Status Origem</Form.Label>
                <Form.Select
                  value={statusOrigemFiltro}
                  onChange={(e) => setStatusOrigemFiltro(e.target.value)}
                >
                  <option value="">Todas</option>
                  <option value="true">Ativas</option>
                  <option value="false">Inativas</option>
                </Form.Select>
              </Form.Group>
            </Row>
            <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <Button id="App-button-cor-principal-escura" onClick={() => listAllPromotora(1)}>
                <FontAwesomeIcon icon={faFilter} style={{ marginRight: '5px' }} />
                Aplicar
              </Button>
              <Button variant="secondary" onClick={() => {
                setMatrizFiltro(''); setCodigoFiltro(''); setNomeFiltro(''); setCnpjFiltro('');
                setCidadeFiltro(''); setStatusOrigemFiltro('');
                listAllPromotora(1);
              }}>
                <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '5px' }} />
                Limpar
              </Button>
            </div>
          </>
          : null}

        {loading ? <Spinner loading={loading} /> : (
          <div className="table-responsive">
            <div>
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th scope="col" id="App-header-table">Promotora</th>
                    <th scope="col" id="App-header-table">CNPJ</th>
                    <th scope="col" id="App-header-table">Cidade</th>
                    <th scope="col" id="App-header-table">Telefone</th>
                    <th scope="col" id="App-header-table">Email</th>
                    <th scope="col" id="App-header-table">Matriz</th>
                    <th scope="col" id="App-header-table">{Originador.DESCRITIVO_GERAL}</th>
                    <ProtectedAction>
                      <th scope="col" id="App-header-table">Alteração</th>
                    </ProtectedAction>
                    <th scope="col" id="App-header-table">Empregadores</th>
                    <th scope="col" id="App-header-table">Financiamento</th>
                    <th scope="col" id="App-header-table">Inf. Gerais</th>
                    <ProtectedAction>
                      <th scope="col" id="App-header-table">Status</th>
                    </ProtectedAction>
                  </tr>
                </thead>
                <tbody>
                  {promotora.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id} - {item.nome}</td>
                      <td>{item.cnpj}</td>
                      <td>{item.cidade}</td>
                      <td>{item.telefoneComercial}</td>
                      <td>{item.email}</td>
                      <td>{item.matriz ? `${item.matriz} - ${item.nomeMatriz}` : '-'}</td>
                      <td>
                        {item.nomesOriginadores || (item.idOriginador ? `${item.idOriginador} - ${item.nomeOriginador || ''}` : '-')}
                      </td>
                      <ProtectedAction>
                        <td>
                          {/* 4. Link de alteração com Slug */}
                          <Link to={`${slug ? `/${slug}` : ''}/origens-promotora/alteracao`} state={{ id: item.id }}>
                            <ButtonAlterar />
                          </Link>
                        </td>
                      </ProtectedAction>
                      <td>
                        {/* 5. Link com Slug */}
                        <Link
                          to={`${slug ? `/${slug}` : ''}/promotora-empregador`}
                          state={{ chamada: 'promotora', idPromotora: item.id, idEmpregador: 0 }}
                        >
                          <ButtonEmpregador />
                        </Link>
                      </td>
                      <td>
                        {/* 5. Link com Slug */}
                          <Link
                              to={`${slug ? `/${slug}` : ''}/promotora-financiamento`}
                              state={{ 
                                chamada: 'promotora', 
                                idPromotora: item.id, 
                                idEmpregador: 0,
                                codigoFinanciamento: item.id, 
                                nomeFinanciamento: item.nome 
                              }}
                            >
                          <ButtonFinanciamento />
                        </Link>
                      </td>
                      <td>
                        {/* 6. Link com Slug */}
                        <Link
                          to={`${slug ? `/${slug}` : ''}/controle-rmc-informacoes-gerais`}
                          state={{ chamada: 'promotora', idPromotora: item.id, idEmpregador: 0 }}
                        >
                          <ButtonInfoGerais />
                        </Link>
                      </td>
                      <ProtectedAction>
                        <td>
                          {item.ativo ?
                            <ButtonInativar onClick={() => ativarInativarPromotora(item.id, item.ativo)} />
                            :
                            <ButtonAtivar onClick={() => ativarInativarPromotora(item.id, item.ativo)} />
                          }
                        </td>
                      </ProtectedAction>
                    </tr>
                  ))}
                </tbody>
              </table>

              <ResponsivePagination
                current={currentPage}
                total={totalPages}
                onPageChange={handlePageChange}
              />

              {confirmOpen && (<ConfirmModal message={currentAction?.ativo ? 'Tem certeza que deseja inativar este item?' : 'Tem certeza que deseja ativar este item?'} onConfirm={handleConfirm} onCancel={() => { setConfirmOpen(false); setCurrentAction(null) }} />)}

            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default PromotoraComponent;
